// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__xqZ48","conversations":"Messages_conversations__-nIpk","emptyList":"Messages_emptyList__mFB1s"};